import styled from 'styled-components';

import theme from '../../../assets/theme';
import { ContentCategory } from '../../../utils/authenticatedHomeUtils';
import { Button } from '../../_atoms/Button';
import { IconWrapper } from '../../_atoms/IconWrapper';

export const MobileCategoryList = ({
  visibleCategories,
  handleSelectCategory,
}: {
  handleSelectCategory: (categoryId: string) => void;
  visibleCategories: ContentCategory[];
}) => {
  return (
    <>
      {visibleCategories.length > 0 && (
        <MobileCategoryListContainer>
          {visibleCategories.map((category, i) => (
            <FilterButton
              key={i}
              onClick={() => handleSelectCategory(category.id)}
              icon={
                <IconWrapper height={'30px'} width={'30px'}>
                  {category.icon}
                </IconWrapper>
              }
            >
              {category.title}
            </FilterButton>
          ))}
        </MobileCategoryListContainer>
      )}
    </>
  );
};

const MobileCategoryListContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 10px;
  width: 100%;
  justify-content: center;
  align-items: center;
  margin-bottom: 20px;
`;

const FilterButton = styled(Button)`
  background-color: ${theme.colors.paleBeige};
  color: ${theme.colors.text.dark};
  border: none;
  border-radius: 10px;
  padding: 10px 20px;
  display: grid;
  grid-template-columns: 40px 1fr;
  justify-content: start;
  align-items: center;
  gap: 10px;
  font-size: 16px;
  font-weight: bold;
  cursor: pointer;
  transition: background-color 0.3s ease;
  max-width: 280px;
  width: 100%;
  height: 80px;
  box-shadow: ${theme.effects.magicFloatingShadow};

  span {
    width: fit-content;
  }

  &:hover,
  &:focus,
  &:active {
    background-color: ${theme.colors.paleBeige}99;
    color: ${theme.colors.text.dark};
    box-shadow: ${theme.effects.magicFloatingShadowHovered};
  }
`;
